import React, { useState } from 'react'
import AlertBanner from 'components/alerts/alert-banner'

import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import Milestone from 'sections/projects/project/project-tasks/milestone/milestone'

export default ({
    tasks,
    emptyCopy
}) => {
    const [currentOpenColumnId, setCurrentOpenColumnId] = useState(null)
    const [currentFocusedTask, setCurrentFocusedTask] = useState(null)
    const [currentEditedTask, setCurrentEditedTask] = useState(null)

    const editTaskName = id => {
        setCurrentEditedTask(id)
    }

    const openMenu = (type, id, focusOnly = false) => {
        setCurrentOpenColumnId(!focusOnly ? type : null)
        setCurrentFocusedTask(id)
    }

    const noop = () => {}

    return (
        <div>
            { (tasks && tasks.length) ?
                <div className={'no-padding'}>
                    <DragDropContext onDragStart={() => { }} onDragEnd={() => { }}>
                        <Droppable droppableId={'tasks'} type="MILESTONE">
                            {provided => (
                                <ul ref={provided.innerRef} className={'milestones-list'}>
                                    <Milestone
                                        key={1}
                                        accountData={null}
                                        addTaskRef={noop}
                                        addMilestoneRef={noop}
                                        applicableUsers={[]}
                                        areMilestonesReordering={false}
                                        clearTaskActivityHistory={noop}
                                        collapseCallback={noop}
                                        currentProject={null}
                                        deleteMilestone={noop}
                                        editTaskName={editTaskName}
                                        forceAddVisibleId={noop}
                                        forceSetCurrentFocusedTask={noop}
                                        handleInputFocus={noop}
                                        visibleIds={[]}
                                        isOpen={true}
                                        isPremium={true}
                                        isQuickTasks={true}
                                        currentEditedTask={currentEditedTask}
                                        currentFocusedTask={currentFocusedTask}
                                        menuState={{
                                            currentOpenColumnId,
                                            currentFocusedTask
                                        }}
                                        mobileSpacerHeight={0}
                                        milestone={{
                                            id: 0,
                                            name: '',
                                            tasks
                                        }}
                                        milestoneIndex={0}
                                        openMenu={openMenu}
                                        project={null}
                                        restoreMilestone={noop}
                                        roles={{}}
                                        searchTerm={''}
                                        setSpacerHeight={noop}
                                        taskActivityHistory={[]}
                                        transitionDelayStartIndex={0}
                                        zIndex={1}
                                        draggedTaskId={null}
                                        isDragging={false}
                                    />
                                </ul>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
                :
                <AlertBanner
                    title={`No tasks to show.`}
                    body={emptyCopy}
                />
            }

        </div>
    )
}